import { useRouter } from 'next/router'
import { getNumberOfInstructors } from '@mc/instructors'
import { paths } from '@mc/paths'
import { useLanguageCleanupEV } from './useLanguageCleanupEV'
import { useLanguageCleanupExperiment } from './useLanguageCleanupExperiment'

export const usePricingText = () => {
  const router = useRouter()
  const { isVariant } = useLanguageCleanupExperiment()
  const isNotQRPage = !router.pathname.includes(
    paths.classRecommendationsResults,
  )
  // We are not replacing the pricing text on the QR page for now
  // since we don't want to interfere with the QR Innovative Swing experiment
  const isLanguageCleanupPricingText = isNotQRPage && isVariant

  useLanguageCleanupEV(isNotQRPage)

  if (!isLanguageCleanupPricingText) {
    return { isLanguageCleanupPricingText }
  }

  return {
    instructors: getNumberOfInstructors(),
    isLanguageCleanupPricingText,
  }
}
